import React, { useContext, useEffect, useState, useCallback } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Modal,
  notification,
  Select,
  InputNumber
} from "antd";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import mergeProps from "../../utils/MergeProps";
const { Option } = Select;

const TemplatePointsForm = ({
  open,
  isEdit,
  currentTemplatePoint,
  onFinish,
  onCancel,
}) => {
  const globals = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [meeting_types, setMeetingTypes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [point_types, setPointTypes] = useState([]);
  const [classifications, setClassifications] = useState([]);
  const fetchMeetingTypes = useCallback(async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/list-meeting-types`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      // add TODOS option with value null
      // response.data.data.unshift({ id: -1, name: "TODOS" });

      setMeetingTypes(response?.data?.data);
    } catch (error) {
      console.error("Error fetching meeting types", error.response);
      notification.error({
        message: "Error obteniendo tipos de reunión",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token]);

  const fetchDepartments = useCallback(async () => {
    try {
      // setLoadingClients(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/list-departments`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );

      // response.data.data.unshift({ id: -1, name: "TODOS" });

      setDepartments(response?.data?.data);
    } catch (error) {
      console.error("Error fetching departments:", error.response);
      notification.error({
        message: "Error obteniendo departamentos",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token]);

  const fetchPointTypes = useCallback(async () => {
    try {
      // setLoadingClients(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/point-types`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      response.data.data = response.data.data.filter((pointType) => pointType.name === "Nuevo" || pointType.name === "Estándar");
      setPointTypes(response?.data?.data);
    } catch (error) {
      console.error("Error fetching point types:", error.response);
      notification.error({
        message: "Error obteniendo tipos de puntos de plantilla",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token]);

  const fetchClassifications = useCallback(async () => {
    try {
      // setLoadingClients(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/classifications`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setClassifications(response?.data?.data);
    } catch (error) {
      console.error("Error fetching classifications:", error.response);
      notification.error({
        message: "Error obteniendo clasificaciones",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token]);

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        name: currentTemplatePoint.name,
        // description: currentTemplatePoint.description,
        meetingTypesId: (currentTemplatePoint.meetingTypesId) ? currentTemplatePoint.meetingTypesId : -1,
        departmentsId: (currentTemplatePoint.departmentsId) ? currentTemplatePoint.departmentsId : -1,
        pointTypesId: currentTemplatePoint.pointTypesId,
        classificationId: currentTemplatePoint.classificationId,
        duration: currentTemplatePoint.duration,
      });
    }
    else{
      form.setFieldsValue({
        duration: 15,
      });
    }
  }, [isEdit, currentTemplatePoint, form, open]);

  useEffect(() => {
    fetchMeetingTypes();
    fetchDepartments();
    fetchPointTypes();
    fetchClassifications();
  }, [
    fetchMeetingTypes,
    fetchDepartments,
    fetchClassifications,
    fetchPointTypes,
  ]);

  const handleComplete = async (values) => {
    try {
      if (values.departmentsId === -1) {
        values.departmentsId = null;
      }
      if (values.meetingTypesId === -1) {
        values.meetingTypesId = null;
      }
      if (isEdit) {
        values.id = currentTemplatePoint.id;
        const response = await axios.put(
          `${globals.SERVICE_API_DB}/v1/update-template-point/${currentTemplatePoint.id}`,
          values,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        if (response?.data?.status === 0) {
          currentTemplatePoint = mergeProps(
            currentTemplatePoint,
            response?.data?.data
          );
          onFinish({ status: "edited" });
        }
        form.resetFields();
        return;
      }
      values.status = "ACTIVE"
      const response = await axios.post(
        `${globals.SERVICE_API_DB}/v1/create-template-point`,
        values,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      onFinish({ status: "created", newTemplatePoint: response?.data?.data });
      form.resetFields();
    } catch (error) {
      console.error("Error submitting form:", error.response);
      notification.error({
        message: "Error guardando punto de plantilla",
        placement: "bottomRight",
      });
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const filterMeetingTypeOption = (input, option) =>
    (option?.children ?? "").toLowerCase().includes(input.toLowerCase());

  const filterDepartmentsOption = (input, option) =>
    (option?.children ?? "").toLowerCase().includes(input.toLowerCase());

  const validatorEmpty = (rule, value) => {
    if (value && value.trim() === "") {
      return Promise.reject("Este campo es requerido");
    }
    return Promise.resolve();
  }

  return (
    <Modal
      title={isEdit ? "Editar Punto de plantilla" : "Crear Punto de plantilla"}
      open={open}
      onOk={handleCancel}
      onCancel={handleCancel}
      footer={null}
    >
      {/* <LoadingModal open={loading} /> */}
      <Form form={form} layout="vertical" onFinish={handleComplete}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="meetingTypesId"
              label="Tipo de reunión"
              rules={[{ required: true, message: "Selecciona una opción" }]}
            >
              <Select
                showSearch
                placeholder="Selecciona una opción"
                filterOption={filterMeetingTypeOption}
                optionFilterProp="children"
                onChange={(value) => {
                  if (value === -1) {
                    form.setFieldsValue({ departmentsId: -1 });
                  }
                  else if (value !== null && form.getFieldValue("departmentsId") === -1) {
                    form.setFieldsValue({ departmentsId: null });
                  }
                }}
              >
                {meeting_types.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="departmentsId"
              label="Departamento"
              rules={[{ required: true, message: "Selecciona una opción" }]}
            >
              <Select
                showSearch
                placeholder="Selecciona una opción"
                filterOption={filterDepartmentsOption}
                optionFilterProp="children"
                onChange={(value) => {
                  if (value === -1) {
                    form.setFieldsValue({ meetingTypesId: -1 });
                  }
                  else if (value !== null && form.getFieldValue("meetingTypesId") === -1) {
                    form.setFieldsValue({ meetingTypesId: null });
                  }
                }}
              >
                {departments.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="pointTypesId"
              label="Tipo de punto"
              rules={[{ required: true, message: "Selecciona una opción" }]}
            >
              <Select placeholder="Selecciona una opción">
                {point_types.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="classificationId"
              label="Clasificación"
              rules={[{ required: true, message: "Selecciona una opción" }]}
            >
              <Select placeholder="Selecciona una opción">
                {classifications.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="name"
          label="Nombre del punto"
          rules={[
            { required: true, message: "Este campo es requerido" },
            { max: 80, message: "Máximo 80 caracteres" },
            { validator: validatorEmpty }
          ]}
        >
          <Input 
            maxLength={80}
            showCount
          />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
              <Form.Item label="Duración estimada" name="duration" tooltip="minutos">
                <InputNumber
                  min={1}
                />
              </Form.Item>
          </Col>
        </Row>

        {/* <Form.Item label="Descripción" name="description">
          <TextArea rows={4} />
        </Form.Item> */}

        <Row justify="end">
          <Col>
            <Button style={{ marginRight: 8 }} type="primary" htmlType="submit">
              {isEdit ? "Actualizar" : "Crear"}
            </Button>
            <Button style={{ marginRight: 8 }} onClick={handleCancel}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default TemplatePointsForm;
